import { lazy } from 'react';

const LockTransactions = lazy(() => import('../pages/LockTransactions'));

const lockTransactionRoute = {
  auth: [
    {
      name: 'lock_transactions',
      path: '/lock-transactions',
      component: LockTransactions,
    },
  ],
};

export default lockTransactionRoute;
